"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var reselect_1 = require("reselect");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var NavTabs_1 = __importDefault(require("atomicComponents/atoms/NavTabs/NavTabs"));
var NavTabsContainer_1 = __importDefault(require("atomicComponents/atoms/NavTabs/NavTabsContainer"));
var Table_1 = __importDefault(require("atomicComponents/atoms/Table/Table"));
var TableBody_1 = __importDefault(require("atomicComponents/atoms/Table/TableBody"));
var Cell_1 = __importDefault(require("atomicComponents/molecules/Table/Cell"));
var ButtonWithModal_1 = __importDefault(require("atomicComponents/organisms/Button/ButtonWithModal"));
var hooks_1 = require("atomicComponents/organisms/SortableHeader/hooks");
var SortHoC_1 = __importDefault(require("atomicComponents/organisms/SortableHeader/SortHoC"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var HeaderMaker_1 = __importDefault(require("containers/TableMaker/HeaderMaker"));
var RowMaker_1 = __importDefault(require("containers/TableMaker/RowMaker"));
var hooks_2 = require("utils/hooks");
var utils_1 = require("utils/selectors/utils");
var Menu_1 = require("../Menu");
var AddNewToolModal_1 = __importDefault(require("../Menu/AddNewToolModal"));
var SearchBar_1 = __importDefault(require("../SearchBar"));
var tableConf_1 = require("../tableConf");
var Header = (0, HeaderMaker_1.default)(tableConf_1.uncuratedTableConf);
var Row = (0, RowMaker_1.default)(tableConf_1.uncuratedTableConf);
var selectUncurated = (0, reselect_1.createSelector)((0, utils_1.makeSelectOrdered)('services_uncurated'), function (servicesUncurated) { return servicesUncurated && servicesUncurated.filter(function (uS) { return !uS.moved; }); });
var Uncurated = function () {
    var _a;
    var _b = __read((0, hooks_2.useSearch)(), 2), searchText = _b[0], setSearchText = _b[1];
    var _c = __read(react_1.default.useState(searchText), 2), reqSearch = _c[0], setReqSearch = _c[1];
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [reqSearch && {
            collection: 'services_uncurated',
            where: [['reducedName', '>=', reqSearch], ['reducedName', '<=', "".concat(reqSearch, "zzz")]],
        }].filter(end2end_1.notFalsy); });
    var uncuratedServices = (0, react_redux_1.useSelector)(selectUncurated);
    var sortedUncuratedServices = (0, hooks_1.useSortArray)(uncuratedServices, tableConf_1.uncuratedTableConf.extractors);
    if (!(0, react_redux_firebase_1.isLoaded)(sortedUncuratedServices) && reqSearch) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Hudled - Naming", description: "Tools database" }), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ display: "flex", height: "100%", pb: 4 }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ width: 1400, display: "flex", flexDirection: "column" }, { children: [(0, jsx_runtime_1.jsxs)(NavTabsContainer_1.default, __assign({ width: "auto", display: "flex", alignItems: "center", justifyContent: "space-between" }, { children: [(0, jsx_runtime_1.jsx)(NavTabs_1.default, { tabs: Menu_1.TOOLS_DB_TABS }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", justifyContent: "flex-end", alignItems: "center", mr: 6 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mr: 1 }, { children: (0, jsx_runtime_1.jsx)(ButtonWithModal_1.default, __assign({ renderOnlyOnOpen: true, modalComponent: AddNewToolModal_1.default }, { children: "Add new tool" })) })), (0, jsx_runtime_1.jsx)(SearchBar_1.default, { searchText: searchText, setSearchText: setSearchText }), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: function () { return setReqSearch((0, end2end_1.reduceName)(searchText) || ''); }, disabled: (((_a = (0, end2end_1.reduceName)(searchText)) === null || _a === void 0 ? void 0 : _a.length) || 0) < 3 }, { children: "Search" }))] }))] })), (0, jsx_runtime_1.jsxs)(Table_1.default, __assign({ maxWidth: 1400, px: 4, ml: -2 }, { children: [(0, jsx_runtime_1.jsx)(Header, {}), (0, jsx_runtime_1.jsxs)(TableBody_1.default, __assign({ width: "100%" }, { children: [sortedUncuratedServices === null || sortedUncuratedServices === void 0 ? void 0 : sortedUncuratedServices.map(function (srv) { return (0, jsx_runtime_1.jsx)(Row, { item: srv }, srv.id); }), !(sortedUncuratedServices === null || sortedUncuratedServices === void 0 ? void 0 : sortedUncuratedServices.length) && (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ pl: 5.25 }, { children: (0, jsx_runtime_1.jsx)(Cell_1.default, { children: "No uncurated tools found" }) }))] }))] }))] })) }))] }));
};
exports.default = react_1.default.memo((0, SortHoC_1.default)(Uncurated));
